import PropTypes from 'prop-types';
import React, { useEffect } from 'react';
import { t } from '../../i18n/translate.js';
import { compareDevices } from '../../services/utilities/deviceComparer.js';
import ArmedStayDeviceItem from './ArmedStayDeviceItem.js';

var ArmedStayDeviceList = function ArmedStayDeviceList(_ref) {
  var devices = _ref.devices,
    setModifiedArmedStayList = _ref.setModifiedArmedStayList,
    modifiedArmedStayList = _ref.modifiedArmedStayList,
    className = _ref.className;
  useEffect(function () {
    setModifiedArmedStayList(devices);
  }, [devices]);
  var onArmedStayChange = function onArmedStayChange(modifiedDevice) {
    setModifiedArmedStayList(function (prevList) {
      return prevList.map(function (armedStayDevice) {
        return armedStayDevice.device.deviceLabel === modifiedDevice.device.deviceLabel ? modifiedDevice : armedStayDevice;
      });
    });
  };
  return modifiedArmedStayList.slice().sort(compareDevices).map(function (armedStayDevice) {
    return /*#__PURE__*/React.createElement(ArmedStayDeviceItem, {
      key: armedStayDevice.device.deviceLabel,
      onChange: onArmedStayChange,
      armedStayDevice: armedStayDevice,
      dataTestId: "armed-stay-device-".concat(armedStayDevice.device.deviceLabel),
      text: t("MPLIB_GUI_LABEL_".concat(armedStayDevice.device.gui.label)),
      subText: armedStayDevice.device.area,
      className: className
    });
  });
};
ArmedStayDeviceList.propTypes = {
  devices: PropTypes.arrayOf(PropTypes.shape({
    device: PropTypes.shape({
      deviceLabel: PropTypes.string.isRequired,
      area: PropTypes.string.isRequired,
      gui: PropTypes.shape({}).isRequired
    }).isRequired,
    armedHome: PropTypes.bool.isRequired
  })).isRequired,
  modifiedArmedStayList: PropTypes.arrayOf(PropTypes.shape({})),
  setModifiedArmedStayList: PropTypes.func.isRequired,
  className: PropTypes.string
};
ArmedStayDeviceList.defaultProps = {
  className: ''
};

export { ArmedStayDeviceList as default };
